import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

const linkBaseStyle = 'inline-flex text-blue-500 hover:underline cursor-pointer';
const buttonBaseStyle =
  'h-12 px-12 rounded inline-flex items-center justify-center overflow-hidden leading-none font-semibold border border-solid focus:outline-none select-none';
const buttonStyles = {
  primary: 'text-white bg-blue-500 hover:bg-blue-700 border-blue-500 hover:border-blue-700',
  outline: 'text-blue-500 hover:text-blue-700 bg-transparent border-blue-500 hover:border-blue-700',
};

const getStyleTuple = kind => kind.split(':');
const getStyle = kind => {
  const [style, variant = 'primary'] = getStyleTuple(kind);
  return style === 'button' ? [buttonBaseStyle, buttonStyles[variant]] : linkBaseStyle;
};

export const KINDS = {
  LINK: 'link',
  BUTTON: 'button',
  BUTTON_PRIMARY: 'button:primary',
  BUTTON_OUTLINE: 'button:outline',
};

const Link = ({ children, kind, className, href, ...props }) => {
  const cn = useClassNames(() => [getStyle(kind), className], [className]);
  return href ? (
    <a data-component="Link" className={cn} href={href} {...props}>
      {children}
    </a>
  ) : (
    <ReactRouterLink data-component="Link" className={cn} {...props}>
      {children}
    </ReactRouterLink>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  kind: PropTypes.oneOf(Object.values(KINDS)),
  href: PropTypes.string,
};

Link.defaultProps = {
  kind: 'link',
  className: '',
  href: null,
};

export default Link;
